import { defineAction } from '../utils/defineAction';

const INIT = 'INIT';
const SUCCESS = 'SUCCESS';
const ERROR = 'ERROR';

const httpActions = [INIT, SUCCESS, ERROR];

export const PATIENT_ENROLL = defineAction(
  'PATIENT_ENROLL',
  ['CHANGE_STEP', 'UPDATE_PATIENT_INFO', 'CLEAR'],
);

export const SUBMIT_PATIENT_ENROLL_FORM = defineAction(
  'SUBMIT_PATIENT_ENROLL_FORM',
  httpActions,
);
